import React, { useState, useEffect } from 'react';
import { eventsAPI, eventTypesAPI, playertoolsAPI } from '../../services/api';

const GameEvents = ({ game, onClose }) => {  const [events, setEvents] = useState([]);
  const [eventTypes, setEventTypes] = useState([]);
  const [playerAssignments, setPlayerAssignments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [showAddForm, setShowAddForm] = useState(false);
  
  const [formData, setFormData] = useState({
    eid: '',
    tid: '',
    plid: '',
    minute: ''
  });
  useEffect(() => {
    fetchEvents();
    fetchEventTypes();
    fetchPlayerAssignments();
  }, [game._id]);

  const fetchEvents = async () => {
    try {
      const response = await eventsAPI.getByGame(game._id);
      setEvents(response.data || []);
    } catch (err) {
      console.error('Failed to fetch events:', err);
      setError('Failed to fetch events');
    } finally {
      setLoading(false);
    }
  };

  const fetchEventTypes = async () => {
    try {
      const response = await eventTypesAPI.getAll();
      setEventTypes(response.data || []);
    } catch (err) {
      console.error('Failed to fetch event types:', err);
    }
  };  const fetchPlayerAssignments = async () => {
    try {
      // Get player assignments for this project
      const response = await playertoolsAPI.getAll({ pid: game.pid._id });
      console.log('Player assignments response:', response);
      const assignmentsData = response.data?.playertools || response.data || [];
      console.log('Player assignments data:', assignmentsData);
      setPlayerAssignments(Array.isArray(assignmentsData) ? assignmentsData : []);
    } catch (err) {
      console.error('Failed to fetch player assignments:', err);
      setPlayerAssignments([]);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      const eventData = {
        pid: game.pid._id,
        rid: game.rid._id,
        gid: game._id,
        eid: formData.eid,
        tid: formData.tid,
        plid: formData.plid,
        minute: parseInt(formData.minute) || 0
      };

      await eventsAPI.create(eventData);
      
      // Reset form and refresh events
      setFormData({ eid: '', tid: '', plid: '', minute: '' });
      setShowAddForm(false);
      fetchEvents();
      
      setSuccessMessage('Event added successfully!');
      setTimeout(() => setSuccessMessage(''), 3000);
    } catch (err) {
      console.error('Error adding event:', err);
      setError(err.response?.data?.message || 'Failed to add event');
    }
  };

  const handleDelete = async (eventId) => {
    if (window.confirm('Are you sure you want to delete this event?')) {
      try {
        await eventsAPI.delete(eventId);
        fetchEvents();
        setSuccessMessage('Event deleted successfully!');
        setTimeout(() => setSuccessMessage(''), 3000);
      } catch (err) {
        setError('Failed to delete event');
      }
    }
  };

  if (loading) return <div className="loading loading-spinner loading-lg"></div>;

  return (
    <dialog open className="modal">
      <div className="modal-box w-11/12 max-w-4xl">
        <div className="flex items-center justify-between mb-6">
          <h3 className="font-bold text-lg">
            Game Events: {game.hid?.name} vs {game.aid?.name}
          </h3>
          <button
            className="btn btn-sm btn-circle btn-ghost"
            onClick={onClose}
          >
            ✕
          </button>
        </div>

        {error && (
          <div className="alert alert-error mb-4">
            <span>{error}</span>
          </div>
        )}

        {successMessage && (
          <div className="alert alert-success mb-4">
            <span>✅ {successMessage}</span>
          </div>
        )}

        {/* Add Event Button */}
        <div className="mb-6">
          <button
            className="btn btn-primary"
            onClick={() => setShowAddForm(!showAddForm)}
          >
            {showAddForm ? 'Cancel' : 'Add Event'}
          </button>
        </div>

        {/* Add Event Form */}
        {showAddForm && (
          <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 mb-6">
            <h4 className="font-semibold mb-4">Add New Event</h4>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                {/* Event Type */}
                <div className="form-control">
                  <label className="label">
                    <span className="label-text">Event Type *</span>
                  </label>
                  <select
                    required
                    value={formData.eid}
                    onChange={(e) => setFormData({...formData, eid: e.target.value})}
                    className="select select-bordered"
                  >
                    <option value="">Select Event Type</option>
                    {eventTypes.map((type) => (
                      <option key={type._id} value={type._id}>
                        {type.name}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Team */}
                <div className="form-control">
                  <label className="label">
                    <span className="label-text">Team</span>
                  </label>
                  <select
                    value={formData.tid}
                    onChange={(e) => setFormData({...formData, tid: e.target.value})}
                    className="select select-bordered"
                  >
                    <option value="">Select Team</option>
                    <option value={game.hid._id}>{game.hid.name}</option>
                    <option value={game.aid._id}>{game.aid.name}</option>
                  </select>
                </div>                {/* Player */}
                <div className="form-control">
                  <label className="label">
                    <span className="label-text">Player</span>
                  </label>
                  <select
                    value={formData.plid}
                    onChange={(e) => setFormData({...formData, plid: e.target.value})}
                    className="select select-bordered"
                    disabled={!formData.tid} // Disable if no team selected
                  >
                    <option value="">
                      {formData.tid ? "Select Player" : "Select Team First"}
                    </option>
                    {formData.tid && playerAssignments
                      .filter(assignment => 
                        assignment.tid?._id === formData.tid && // Player assigned to selected team
                        assignment.pid?._id === game.pid._id   // Player assigned to this project
                      )
                      .map((assignment) => (                        <option key={assignment._id} value={assignment.plid?._id}>
                          #{assignment.num} {assignment.plid?.surname} {assignment.plid?.prename}
                        </option>
                      ))}
                  </select>
                  {formData.tid && (
                    <label className="label">
                      <span className="label-text-alt text-green-600">
                        {playerAssignments.filter(a => a.tid?._id === formData.tid && a.pid?._id === game.pid._id).length} player(s) assigned to this team
                      </span>
                    </label>
                  )}
                </div>

                {/* Minute */}
                <div className="form-control">
                  <label className="label">
                    <span className="label-text">Minute</span>
                  </label>
                  <input
                    type="number"
                    min="0"
                    max="120"
                    value={formData.minute}
                    onChange={(e) => setFormData({...formData, minute: e.target.value})}
                    className="input input-bordered"
                    placeholder="0"
                  />
                </div>
              </div>

              <div className="flex gap-2">
                <button type="submit" className="btn btn-primary">
                  Add Event
                </button>
                <button 
                  type="button" 
                  className="btn btn-ghost"
                  onClick={() => setShowAddForm(false)}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        )}

        {/* Events List */}
        <div className="space-y-3">
          <h4 className="font-semibold">Events ({events.length})</h4>
          
          {events.length === 0 ? (
            <div className="text-center py-8">
              <div className="text-4xl mb-2">⚽</div>
              <p className="text-gray-500">No events recorded for this game yet.</p>
            </div>
          ) : (
            <div className="space-y-2">
              {events
                .sort((a, b) => a.minute - b.minute)
                .map((event) => (
                  <div 
                    key={event._id} 
                    className="bg-white border border-gray-200 rounded-lg p-3 flex items-center justify-between"
                  >
                    <div className="flex items-center gap-4">
                      <div className="bg-blue-100 text-blue-800 text-sm font-medium px-2 py-1 rounded">
                        {event.minute}'
                      </div>
                      <div className="font-medium">
                        {event.eid?.name || 'Unknown Event'}
                      </div>
                      {event.tid?.name && (
                        <div className="text-sm text-gray-600">
                          {event.tid.name}
                        </div>
                      )}                      {event.plid && (
                        <div className="text-sm text-gray-600">
                          {event.plid.surname} {event.plid.prename}
                        </div>
                      )}
                    </div>
                    
                    <button
                      className="btn btn-sm btn-error btn-square"
                      onClick={() => handleDelete(event._id)}
                      title="Delete event"
                    >
                      🗑️
                    </button>
                  </div>
                ))}
            </div>
          )}
        </div>

        <div className="modal-action">
          <button className="btn" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </dialog>
  );
};

export default GameEvents;
